import { Loading } from "."
import React from "react"

export default (props) =>
  props.loading ? <Loading small={props.small} /> : props.children
